(function () {
  // Ingredient tabs: bring the current tab into view when it starts off-screen (phones)
  var tabs = document.querySelector('.lf-tabs');
  var current = tabs && tabs.querySelector('[aria-current="page"]');
  if (current && current.offsetLeft + current.offsetWidth > tabs.scrollLeft + tabs.clientWidth) {
    tabs.scrollLeft = current.offsetLeft - parseFloat(getComputedStyle(tabs).paddingLeft);
  }

  // Phone menu
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lf-menu]');
    if (!btn) return;
    var header = btn.closest('.lf-header');
    var open = header.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Close' : 'Menu';
  });

  // Close the phone menu after choosing an in-page link
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.lf-menu a');
    if (!link) return;
    var header = link.closest('.lf-header');
    header.classList.remove('is-open');
    var btn = header.querySelector('[data-lf-menu]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.textContent = 'Menu'; }
  });
})();
